<template>

    <Head>
        <meta name="title" content="English Exam Vocabulary + Quiz and Pronunciations" />
        <title>English Exam Vocabulary</title>

        <meta name="description"
            content="You can learn the 600 most important words and their meanings from English exams with Quiz here. Click on the sound icon to listen to the pronunciation of the words." />

    </Head>
    <div class="container pt-5 mt-3 mb-5">

        <div class="row mx-auto">
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
            <div class="col-12 col-md-8 mx-auto">

                <h1 class="archivo">English Exam Vocabulary + Quiz and Pronunciations</h1>

                <div v-if="false" class="ad-container-yatay">
                    <Adsense data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990" data-ad-format="auto"
                        :data-full-width-responsive="true">
                    </Adsense>
                </div>

                <p>In the list below, 600 English words are shared along with their meanings. By clicking on the sound
                    icon, you can listen to the <b>pronunciation</b> of each word, and by hovering over the word, you
                    can see an <b>example usage of that word in a sentence</b>. Additionally, you can work on these
                    words with the <b>Quiz</b> by clicking the 'Go to Quiz' button. You can remove words you already
                    know by clicking on them. If you log in to Diziyle Öğren, words you've already learned will be
                    automatically removed from the list. This way, you can focus only on the words you don’t know. We
                    hope this will be helpful for you. We wish you success in your exam 😊</p>



                <div class="row mt-5">
                    <WordListComponent v-if="isReady" :wordList="wordListData.words" :sliderValueArg="[1, 9]">
                    </WordListComponent>
                    <Loading style="" v-else />
                </div>
                <SuggestedBlogs></SuggestedBlogs>
            </div>
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import WordListComponent from "../../../components/Shared/WordListComponent.vue";
import SuggestedBlogs from "../../../components/Shared/SuggestedBlogs.vue";
export default {
    data() {
        return {
            wordListData: {},
            isReady: false
        };
    },
    components: {
        WordListComponent,
        SuggestedBlogs
    },

    created() {
        this.$store.commit('setEditOption', false)
        axios.get('/api/WordList/GetWordListV2', { params: { type: 5, id: 20712, MeanLanguageType: 1 } }).then((response) => {
            this.wordListData = response.data

        }).finally(() => {
            this.isReady = true
        }).catch(error => {
            console.log(error.response.data)
        })
    }
}

</script>